/**
 * Homepage Lazy Loader
 * - Activates video-lazy containers when scrolled into view
 * - Shows thumbnail immediately, loads <video> in background, autoplays on canplay
 * - Manages content-visibility for below-fold sections
 */

(function () {
  'use strict';

  // ── Video Lazy Loading ──────────────────────────────────────────────
  var videoObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      activateVideo(entry.target);
      videoObserver.unobserve(entry.target);
    });
  }, {
    rootMargin: '200px 0px',
    threshold: 0
  });

  function activateVideo(container) {
    if (container.dataset.videoActivated) return;
    container.dataset.videoActivated = '1';

    var tpl = container.querySelector('[data-video-tpl]');
    if (!tpl) return;

    // Clone video from <template>
    var videoEl = tpl.content.querySelector('video');
    if (!videoEl) return;

    var video = videoEl.cloneNode(true);
    video.style.opacity = '0';
    video.style.position = 'absolute';
    video.style.inset = '0';
    video.style.width = '100%';
    video.style.height = '100%';
    video.style.objectFit = 'cover';
    video.style.transition = 'opacity 0.3s';

    // Insert hidden video, let it buffer
    container.appendChild(video);
    video.preload = 'auto';

    // When buffered enough, swap out the thumbnail
    function onReady() {
      video.style.opacity = '1';
      var thumb = container.querySelector('.video-lazy__thumb');
      if (thumb) thumb.style.display = 'none';
      video.play().catch(function () {});
    }

    if (video.readyState >= 3) {
      onReady();
    } else {
      video.addEventListener('canplay', onReady, { once: true });
    }
  }

  // ── Initialize ──────────────────────────────────────────────────────
  function initVideoLazy() {
    var containers = document.querySelectorAll('[data-video-lazy]');
    containers.forEach(function (c) {
      videoObserver.observe(c);
    });
  }

  // Re-observe after gender swap (new content cloned from <template>)
  document.addEventListener('genderSwapped', function () {
    initVideoLazy();
  });

  // ── Boot ────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideoLazy);
  } else {
    initVideoLazy();
  }
})();
